<div class="form-content">
  <!-- CREATE GROUP -->
  <form action="" method="post" accept-charset="utf-8" (ngSubmit)="submit(form)" #form="ngForm">
    <div class="col-md-7 col-12 form-box p-0 ">
      <div class="form-section collapse-section open">
        <div class="d-flex align-items-center justify-content-between collapse-header">
          <h6 class="text-collapse m-0">{{'Group'|translate}}</h6>
          <div class="d-flex">
            <button kendoButton type="button" class="btn btn-primary btn-collapse" [icon]="'arrow-chevron-down'"></button>
          </div>
        </div>
        <div class="form-section">
          <div class="form-row">
            <div class="hasValue form-group col-md-6" [class.has-error]="subject.invalid && (subject.dirty || subject.touched)">
              <label>{{'Create Group'|translate}}</label>
              <input type="text" [(ngModel)]="ticketGroupName" [disabled]="!permisions.EDIT_TICKET_MANAGEMENT" required class="mnc-control" ngModel name="subject" #subject="ngModel" autofocus="">
            </div>
            <div class="form-group col-md-6">
              <button type="submit" class="btn-save" [disabled]="onSubmit || form.invalid || (!permisions.EDIT_TICKET_MANAGEMENT)" kendoButton primary="true"><i *ngIf="onSubmit" class="fa fa-spinner fa-spin"></i>{{'save'|translate}}</button>
            </div>
            <div class="col-md-12">
              <div *ngFor="let group of ticketsGroups;let z = index;">
                <div class="form-row">
                  <div class="form-group hasValue col-md-6">
                    <label>{{group.name|translate}}</label>
                    <kendo-multiselect name="groupName--{{z}}" [disabled]="!permisions.EDIT_TICKET_MANAGEMENT" ngModel [textField]="'fullName'" [valueField]="'user_id'" [data]="data" (valueChange)="selectedUser(group.users, group.id)" [(ngModel)]="group.users"></kendo-multiselect>
                  </div>
                  <div class="form-group managers-managment col-md-2">
                    <div class="d-flex">
                      <button type="button" [disabled]="!permisions.EDIT_TICKET_MANAGEMENT" class="remove" (click)="deleteGroup(group.id)"><i class="fa fa-minus" aria-hidden="true"></i></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  <!-- CREATE GROUP -->

  <!-- CREATE CATEGORY Skynet-Ticket -->
  <form action="" method="post" accept-charset="utf-8" (ngSubmit)="submitCategory(formCategory, 'Skynet-Ticket')" #formCategory="ngForm">
    <div class="col-md-7 col-12 form-box p-0 ">
      <div class="form-section collapse-section open">
        <div class="d-flex align-items-center justify-content-between collapse-header">
          <h6 class="text-collapse m-0">{{'Category Skynet-Ticket'|translate}}</h6>
          <div class="d-flex">
            <button kendoButton type="button" class="btn btn-primary btn-collapse" [icon]="'arrow-chevron-down'"></button>
          </div>
        </div>
        <div class="form-section">
          <div class="form-row">
            <div class="hasValue form-group col-md-6" [class.has-error]="category.invalid && (category.dirty || category.touched)">
              <label>{{'Create Category for Skynet-Ticket'|translate}} *</label>
              <input type="text" required class="mnc-control"  [disabled]="!permisions.EDIT_TICKET_MANAGEMENT"  [(ngModel)]="ticketCategoryName" ngModel name="category" #category="ngModel" autofocus="">
            </div>
            <div class="form-group col-md-6">
              <button type="submit" class="btn-save" [disabled]="onSubmit || formCategory.invalid || (!permisions.EDIT_TICKET_MANAGEMENT)" kendoButton primary="true"><i *ngIf="onSubmit" class="fa fa-spinner fa-spin"></i>{{'save'|translate}}</button>
            </div>
            <div class="col-md-12">
              <div *ngFor="let category of categorySkynetTicketData;let z = index;">
                <div class="form-row">
                  <div class="form-group hasValue col-md-6">
                    <label>{{category.name|translate}}</label>
                    <kendo-multiselect name="categoryName--{{z}}" [disabled]="!permisions.EDIT_TICKET_MANAGEMENT" ngModel [textField]="'name'" [valueField]="'id'" [data]="ticketsGroups" (valueChange)="onCategoryChanged(category.group, category.id)" [(ngModel)]="category.group" [(value)]="category.group"></kendo-multiselect>
                  </div>
                  <div class="form-group managers-managment col-md-2">
                    <div class="d-flex">
                      <button type="button" [disabled]="!permisions.EDIT_TICKET_MANAGEMENT" class="remove" (click)="removeCategory(category.id)"><i class="fa fa-minus" aria-hidden="true"></i></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  <!-- CREATE CATEGORY Skynet-Ticket -->

  <!-- CREATE CATEGORY IT-Ticket -->
  <form action="" method="post" accept-charset="utf-8" (ngSubmit)="submitCategory(formCategory, 'IT-Ticket')" #formCategory="ngForm">
    <div class="col-md-7 col-12 form-box p-0 ">
      <div class="form-section collapse-section open">
        <div class="d-flex align-items-center justify-content-between collapse-header">
          <h6 class="text-collapse m-0">{{'Category IT-Ticket'|translate}}</h6>
          <div class="d-flex">
            <button kendoButton type="button" class="btn btn-primary btn-collapse" [icon]="'arrow-chevron-down'"></button>
          </div>
        </div>
        <div class="form-section">
          <div class="form-row">
            <div class="hasValue form-group col-md-6" [class.has-error]="category.invalid && (category.dirty || category.touched)">
              <label>{{'Create Category for IT-Ticket'|translate}} *</label>
              <input type="text" required class="mnc-control"  [disabled]="!permisions.EDIT_TICKET_MANAGEMENT"  [(ngModel)]="ticketCategoryName" ngModel name="category" #category="ngModel" autofocus="">
            </div>
            <div class="form-group col-md-6">
              <button type="submit" class="btn-save" [disabled]="onSubmit || formCategory.invalid || (!permisions.EDIT_TICKET_MANAGEMENT)" kendoButton primary="true"><i *ngIf="onSubmit" class="fa fa-spinner fa-spin"></i>{{'save'|translate}}</button>
            </div>
            <div class="col-md-12">
              <div *ngFor="let category of categoryItTicketData;let z = index;">
                <div class="form-row">
                  <div class="form-group hasValue col-md-5">
                    <label>{{category.name|translate}}</label>
                    <kendo-multiselect name="categoryName--{{z}}" [disabled]="!permisions.EDIT_TICKET_MANAGEMENT" ngModel [textField]="'name'" [valueField]="'id'" [data]="ticketsGroups" (valueChange)="onCategoryChanged(category.group, category.id)" [(ngModel)]="category.group" [(value)]="category.group"></kendo-multiselect>
                  </div>
                  <div class="form-group managers-managment col-md-1">
                    <div class="d-flex">
                      <button type="button" [disabled]="!permisions.EDIT_TICKET_MANAGEMENT" class="remove" (click)="removeCategory(category.id)"><i class="fa fa-minus" aria-hidden="true"></i></button>
                    </div>
                  </div>

                  <div class="form-group hasValue col-md-5">
                    <label> {{'subcategory of'|translate}} - {{category.name|translate}}</label>
                    <kendo-multiselect name="subcategory--{{z}}" [disabled]="!permisions.EDIT_TICKET_MANAGEMENT" ngModel [textField]="'name'" [valueField]="'id'" [data]="category.subcategory" (valueChange)="onSubcategoryChanged(category.subcategory, category.id)" [(ngModel)]="category.subcategory" [(value)]="category.subcategory"></kendo-multiselect>
                  </div>
                  <div class="form-group managers-managment col-md-1">
                    <div class="d-flex">
                      <button type="button" [disabled]="!permisions.EDIT_TICKET_MANAGEMENT" class="plus mx-auto" (click)="addSubcategory(category.id)"><i class="fa fa-plus" aria-hidden="true"></i></button>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  <!-- CREATE CATEGORY IT-Ticket -->

  <!-- OLD OPTION OF GRUOPE USERS -->
  <!-- <div class="col-md-7 col-12 form-box p-0" *ngFor="let group of ticketsGroups;let z = index;">
    <div class="form-section collapse-section open">
      <div class="d-flex align-items-center justify-content-between collapse-header">
        <h6 class="text-collapse m-0">{{group.name |translate}}</h6>
        <div class="d-flex">
          <button kendoButton type="button" class="btn btn-primary btn-collapse" [icon]="'arrow-chevron-down'">
          </button>
        </div>
      </div>
      <div class="form-section">
        <div class="form-row">
          <div class="form-group col-md-8">
            <div class="form-row">
              <div class="form-group col-md-3 hasValue">
                <label>{{'User'|translate}} *</label>
                <kendo-dropdownlist name="UserGroups--{{z}}" [filterable]="true" [kendoDropDownFilter]="{caseSensitive: false,operator: 'contains'}" [disabled]="!permisions.EDIT_TICKET_MANAGEMENT" [data]="data" ngModel [(ngModel)]="group.users.id" (valueChange)="selectedUser(group.users.id, group.id)"
                [textField]="'fullName'" [valueField]="'id'"></kendo-dropdownlist>
              </div>
              <div class="form-group managers-managment col-md-2">
                <div class="d-flex">
                  <button type="button" [disabled]="!permisions.EDIT_TICKET_MANAGEMENT" class="plus mr-2" (click)="saveUser()">
                    <i class="fa fa-plus" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
            <div *ngFor="let userGroup of usersData; let i = index">
              <div *ngIf="userGroup.group_id == group.id">
                <div class="form-row">
                  <div class="form-group hasValue col-md-3">
                    <kendo-dropdownlist name="UserGroups--{{z}}--{{i}}" [disabled]="!permisions.EDIT_TICKET_MANAGEMENT" disabled ngModel [(ngModel)]="userGroup.name"></kendo-dropdownlist>
                  </div>
                  <div class="form-group managers-managment col-md-2">
                    <div class="d-flex">
                      <button type="button" [disabled]="!permisions.EDIT_TICKET_MANAGEMENT" class="remove" (click)="removeUserGroup(userGroup.id)">
                        <i class="fa fa-minus" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="permisions.EDIT_TICKET_MANAGEMENT" class="form-group col-md-4" style="display: flex; align-items: flex-end; justify-content: flex-end; cursor: pointer;" (click)="deleteGroup(group.id)">
            <img src="../../../../../../assets/images/delete.svg" alt="">
          </div>
        </div>
      </div>
    </div>
  </div> -->
  <!-- OLD OPTION OF GRUOPE USERS -->


  <div class="collapse-section history-section">
    <div  class="d-flex align-items-center justify-content-between collapse-header">
      <h6 class="text-collapse m-0">{{'history'|translate}}</h6>
      <div class="d-flex">
        <button kendoButton type="button" class="btn btn-primary btn-collapse" [icon]="'arrow-chevron-down'"></button>
      </div>
    </div>
    <div class="form-group mt-2 mb-0">
      <div class="log-row" *ngFor="let item of logs">
        <div class="d-flex">
          <i class="fa fa-user" aria-hidden="true"></i>
          <div>
            <h1>{{item.causer.name }} {{item.causer.surname }}</h1>
            <div class="action">
              <h1>{{item.attribute | translate }} {{item.action | translate }} </h1>
              <div class="values" *ngIf="item.oldValue != null || item.value != null" >
                <span *ngIf="item.oldValue != null" [innerHTML]="item.oldValue"></span>
                <span *ngIf="item.oldValue != null"> ---> </span>
                <span *ngIf="item.value != null" [innerHTML]="item.value"></span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <h5 class="date-value">{{ item.created_at | date: 'dd.MM.yyyy HH:mm' }}</h5>
        </div>
      </div>
    </div>
  </div>
</div>


<kendo-dialog title="{{'Add new subcategory'|translate}}" *ngIf="displayAddNewSubcategory" (close)="declineAddNewSubcategory()" style="z-index: 99999 !important;" [minWidth]="250" [width]="450">
  <div class="modal-body">
    <div class="hasValue form-group col-md-12">
      <label>{{'Add Subcategory'|translate}} *</label>
      <input type="text" required class="mnc-control" [(ngModel)]="newSubcategory" ngModel name="newsubcategory" #newsubcategory="ngModel" autofocus="">
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn-save" (click)="confirmAddNewSubcategory()" kendoButton primary="true">{{'yes'|translate}}</button>
    <button class="btn-cancel" kendoButton (click)="declineAddNewSubcategory()" type="button">{{'no'|translate}}</button>
  </div>
</kendo-dialog>


<kendo-dialog title="{{'Confirm'|translate}}" *ngIf="displayDeleteGroup" (close)="declineDeleteGroup()" style="z-index: 99999 !important;" [minWidth]="250" [width]="450">
  <p class="confirm-delete-text"> {{'Are you sure you want to delete'|translate}}?</p>
  <div class="modal-footer">
    <button class="btn-save" (click)="confirmDeleteGroup()" kendoButton primary="true">{{'yes'|translate}}</button>
    <button class="btn-cancel" kendoButton (click)="declineDeleteGroup()" type="button">{{'no'|translate}}</button>
  </div>
</kendo-dialog>
